import React from 'react';
import { Code, Briefcase, Rocket } from 'lucide-react';
const milestones = [{
  year: 'Age 16',
  title: 'The Beginning',
  description: 'Started my first business. Built web apps with PHP, JavaScript, CSS, and Python alongside school. Internships and projects at an IT company.',
  icon: Code,
  color: 'bg-blue-500'
}, {
  year: 'Age 17-19',
  title: 'The Turning Point',
  description: 'Built a full-time web design and web app development agency. A client asked for a CRM system for their leads – that was the starting point.',
  icon: Briefcase,
  color: 'bg-purple-500'
}, {
  year: 'Age 19-23',
  title: 'Full-Time CRM Focus',
  description: 'Full-time focus on CRM systems. Grew through referrals. Today we work with over 1,200 sales professionals.',
  icon: Rocket,
  color: 'bg-[#FF5722]'
}];
export function JourneyTimeline() {
  return <section className="py-20 bg-[#0A0E27]" data-id="element-49" data-mp="1k4pnvrww7tz9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-50" data-mp="1k7ll1e0x2emn">
        <div className="text-center mb-16" data-id="element-51" data-mp="1xwbtslucduww">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-52" data-mp="1syk6640qcuyi">
            My Journey to CRM Expert
          </h2>
          <p className="text-[#94A3B8] max-w-2xl mx-auto" data-id="element-53" data-mp="26yutwy6qttfg">
            No theory, just years of hands-on experience in development and
            sales.
          </p>
        </div>

        <div className="relative" data-id="element-54" data-mp="1e9e7qi9pv8ro">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-[#1E293B] -translate-y-1/2 z-0" data-id="element-55" data-mp="1e7b7z6iri19r"></div>

          {/* Connecting Line (Mobile) */}
          <div className="md:hidden absolute top-0 left-8 h-full w-1 bg-[#1E293B] z-0" data-id="element-56" data-mp="1o08urousece6"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-57" data-mp="1j7yx1mnfk81c">
            {milestones.map((milestone, index) => <div key={index} className="relative flex flex-col md:items-center md:text-center pl-20 md:pl-0 group" data-id="element-58" data-mp="vh3d1bp7uh4n" data-mpi={index}>
                {/* Icon Marker */}
                <div className={`absolute left-0 md:left-1/2 md:-translate-x-1/2 top-0 md:top-1/2 md:-translate-y-[calc(50%+3rem)] w-16 h-16 rounded-full ${milestone.color} flex items-center justify-center shadow-lg shadow-black/50 border-4 border-[#0A0E27] transition-transform duration-300 group-hover:scale-110`} data-id="element-59" data-mp="2qki3twa9ut2y">
                  <milestone.icon className="w-8 h-8 text-white" data-id="element-60" data-mp="27oi7yae6b5e3" />
                </div>

                {/* Content Card */}
                <div className="mt-4 md:mt-32 bg-[#141B3A] border border-[#1E293B] p-6 rounded-xl hover:border-[#334155] transition-colors w-full" data-id="element-61" data-mp="2cmtjqqo13pyy">
                  <div className="inline-block px-3 py-1 rounded-full bg-[#1E293B] text-[#FF5722] text-sm font-bold mb-3 border border-[#334155]" data-id="element-62" data-mp="2lnrdmg4r6h3t">
                    {milestone.year}
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-63" data-mp="w93fjyvzxif">
                    {milestone.title}
                  </h3>
                  <p className="text-[#94A3B8] text-sm leading-relaxed" data-id="element-64" data-mp="1lejm7bggzljl">
                    {milestone.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}